import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';

const VTable = lazy(async () => {
  const { VTable } = await import('../sites/vtable');
  return { default: VTable };
});
const VTableExample = lazy(async () => {
  const { Example } = await import('../sites/vtable/views/example');
  return { default: Example };
});
const VTableDemo = lazy(async () => {
  const { Demo } = await import('../sites/vtable/views/demo');
  return { default: Demo };
});
const VTableExampleReact = lazy(async () => {
  const { Example } = await import('../sites/vtable/views/example-react');
  return { default: Example };
});
const VTableDemoReact = lazy(async () => {
  const { Demo } = await import('../sites/vtable/views/demo-react');
  return { default: Demo };
});
const VTableExampleVue = lazy(async () => {
  const { Example } = await import('../sites/vtable/views/example-vue');
  return { default: Example };
});
const VTableDemoVue = lazy(async () => {
  const { Demo } = await import('../sites/vtable/views/demo-vue');
  return { default: Demo };
});
const VTableExampleOpeninula = lazy(async () => {
  const { Example } = await import('../sites/vtable/views/example-openinula');
  return { default: Example };
});
const VTableDemoOpeninula = lazy(async () => {
  const { Demo } = await import('../sites/vtable/views/demo-openinula');
  return { default: Demo };
});
const VTableGuide = lazy(async () => {
  const { Guide } = await import('../sites/vtable/views/guide');
  return { default: Guide };
});
const VTableContributing = lazy(async () => {
  const { Contributing } = await import('../sites/vtable/views/contributing');
  return { default: Contributing };
});
const VTableOption = lazy(async () => {
  const { Option } = await import('../sites/vtable/views/option');
  return { default: Option };
});
const VTableAPI = lazy(async () => import('../sites/vtable/views/api'));
const VTableFAQ = lazy(async () => import('../sites/vtable/views/faq'));
const VTableChangelog = lazy(async () => {
  const { Changelog } = await import('../sites/vtable/views/changelog');
  return { default: Changelog };
});
const VTableEntry = lazy(async () => {
  const { Entry } = await import('../sites/vtable/views/entry');
  return { default: Entry };
});
const VTablePage = lazy(async () => {
  const { ChartPage } = await import('../sites/vtable/views/chartpage');
  return { default: ChartPage };
});
const VTablePlayground = lazy(async () => {
  const { Playground } = await import('../sites/vtable/views/playground');
  return { default: Playground };
});

export const vtableRoutes: RouteObject[] = [
  {
    path: '/vtable',
    element: (
      <Suspense>
        <VTable />
      </Suspense>
    ),
  },
  {
    path: '/vtable/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VTableExample />
      </Suspense>
    ),
  },
  {
    path: '/vtable/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VTableDemo />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableDemo />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/example-react',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VTableExampleReact />
      </Suspense>
    ),
  },
  {
    path: '/vtable/demo-react',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VTableDemoReact />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableDemoReact />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/example-vue',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VTableExampleVue />
      </Suspense>
    ),
  },
  {
    path: '/vtable/demo-vue',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VTableDemoVue />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableDemoVue />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/example-openinula',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VTableExampleOpeninula />
      </Suspense>
    ),
  },
  {
    path: '/vtable/demo-openinula',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VTableDemoOpeninula />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableDemoOpeninula />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/contributing',
    loader: loaders.contributingLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableContributing />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableContributing />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/option',
    loader: loaders.optionLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableOption />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableOption />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/api',
    loader: loaders.vTableApiLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableAPI />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableAPI />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/faq',
    loader: loaders.faqLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableFAQ />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableFAQ />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/changelog',
    loader: loaders.changelogLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableChangelog />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VTableChangelog />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vtable/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTableEntry />
      </Suspense>
    ),
  },
  {
    path: '/vtable/playground',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTablePlayground />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vtable/chartpage',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VTablePage />
      </Suspense>
    ),
  },
];
